import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';

@Component({
  selector: 'ws-edit-promo-text-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './edit-promo-text.dialog.html',
  standalone: false,
})
export class EditPromoTextDialog implements OnInit {
  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {}

  @ViewChild(DialogComponent) dialog!: DialogComponent;

  @Input() set value(val: string | null | undefined) {
    this.form.patchValue({ promoText: val ?? '' });
    this.cdr.markForCheck();
  }

  @Output() readonly saved = new EventEmitter<string>(true);

  public submitting = false;

  form = this.fb.group({
    promoText: ['', []], // Allow empty string, no Validators.required or minLength
  });

  ngOnInit() {
    this.form.enable();
  }

  openDialog() {
    this.form.enable();
    this.form.markAsPristine();
    this.dialog.open();
    this.cdr.markForCheck();
  }

  closeDialog() {
    this.dialog.close();
    this.form.enable();
  }

  submit() {
    if (this.form.invalid) return;
    this.submitting = true;
    this.saved.emit(this.form.value.promoText || '');
    this.closeDialog();
    this.submitting = false;
  }
}
